import { SBModel } from '@supplement-bacon/react-toolkit/models'
import { NamePath } from 'antd/es/form/interface'
import { Localizable } from '../Localizable'
import { PolicyShift } from './PolicyShift'

interface Policy extends SBModel, Localizable<PolicyLocalizable> {
  company: number
  name: string
  policyShifts: PolicyShift[]
}

interface PolicyLocalizable {
  description: string
}

const baseFormItemName = (dayId: number, shiftId: number): NamePath => [
  'policyShifts',
  dayId + '-' + shiftId,
]
const switchFormItemName = (dayId: number, shiftId: number): NamePath => [
  ...baseFormItemName(dayId, shiftId),
  'enabled',
]
const isSwitchEnabledFromValues = (
  values: any,
  dayId: number,
  shiftId: number
): boolean => !!values?.policyShifts?.[`${dayId}-${shiftId}`]?.enabled

export { baseFormItemName, isSwitchEnabledFromValues, switchFormItemName }
export type { Policy }
